/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/passkey/credentials`,
    // @ts-ignore for sm-axios
    urlTemplate: '/passkey/credentials',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Returns the WebAuthn credential descriptors of the user's existing passkeys, to exclude during passkey enrolment
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * The token of the user enrolling the passkey.
     */
    token: string
  }
}

export interface Response {
  credentials: {
    type: 'public-key'
    /**
     * base64url credential id
     */
    id: string
    transports?: string[]
  }[]
}

